import React, { createContext, useContext, useState, useEffect } from "react";
import { Link } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(null);
    const [userId, setUserId] = useState(null);
    const [sessionId, setSessionId] = useState(null);
    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [mobile, setMobile] = useState(null);
    const [isAuthReady, setIsAuthReady] = useState(false);
    const [prefix, setPrefix] = useState(null);
    const [accountId, setAccountId] = useState(null);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    useEffect(() => {
        const auth = localStorage.getItem("userAuth");
        if (auth) {
            const userAuth = JSON.parse(auth);
            setToken(userAuth.token);
            setUserId(userAuth.userId);
            setSessionId(userAuth.sessionId);
            setPrefix(userAuth.prefix);
            setName(userAuth.name);
            setEmail(userAuth.email);
            setMobile(userAuth.mobile);
            setAccountId(userAuth.accountId);
        }
        if (window.ethereum) {
            checkConnection();

            window.ethereum.on("accountsChanged", (accounts) => {
                accountChanged(accounts);
            });

            window.ethereum.on('disconnect', () => {
                disConnected();
            });
        }

        setIsAuthReady(true);

        return () => {
            if (window.ethereum) {
                window.ethereum.removeListener('disconnect', () => {
                    disConnected();
                });
                window.ethereum.removeListener('accountsChanged', (accounts) => {
                    accountChanged(accounts);
                });
            }
        };
    }, []);

    const checkConnection = async () => {
        const path = window.location?.pathname || '';
        if (!path.includes('/signup') && !path.includes('/home')) {
            return
        }
        const isConnected = await isWalletConnected();

        if (!isConnected) {
            setMessage("Wallet is not connected, Please login again.");
            setShowErrorModal(true);
        }
    }

    const isWalletConnected = async () => {
        if (!window.ethereum) return false;
        try {
            const accounts = await window.ethereum.request({ method: 'eth_accounts' });
            return accounts.length > 0;
        } catch (err) {
            console.error("Error checking wallet connection:", err);
            return false;
        }
    };

    const accountChanged = (accounts) => {
        const auth = localStorage.getItem("userAuth");
        let ac = '';
        if (auth) {
            const userAuth = JSON.parse(auth);
            ac = userAuth.accountId;
        }

        if (ac?.toLowerCase() == accounts[0]?.toLowerCase()) {
            setShowErrorModal(false);
            setMessage("");
            setError("");
            return;
        }

        const path = window.location?.pathname || '';

        if (!path.includes('/signup') && !path.includes('/home') && !path.includes('/login')) {
            setMessage("Account has been changed, Please login again.");
            setError(
                `Previous account: ${ac ? '...' + ac.slice(-20) : 'N/A'}\n` +
                `Current account: ${accounts[0] ? '...' + accounts[0].slice(-20) : 'N/A'}`
            );
            setShowErrorModal(true);
        } else {
            setAccountId(accounts[0]);
        }
    };

    const disConnected = () => {
        setMessage("Wallet disconnected, Please login again.");
        setShowErrorModal(true);
    };

    const logout = (r) => {
        localStorage.removeItem("userAuth");
        setToken(null);
        setUserId(null);
        setSessionId(null);
        setPrefix(null);
        setName(null);
        setEmail(null);
        setMobile(null);
        setAccountId(null);
    };

    return (
        <AuthContext.Provider
            value={{
                token,
                userId,
                sessionId,
                name,
                email,
                mobile,
                prefix,
                accountId,
                setToken,
                setUserId,
                setSessionId,
                setPrefix,
                setName,
                setEmail,
                setMobile,
                setAccountId,
                isAuthReady
            }}
        >
            <div>
                {children}
                {/* Modal */}
                {showErrorModal && (
                    <div
                        className={"modal fade show"}
                        tabIndex="-1"
                        aria-modal="true"
                        role="dialog"
                        style={{ display: 'block', backgroundColor: 'rgba(0, 0, 0, 0.5)' }} // backdrop
                    >
                        <div className="modal-dialog modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Error</h5>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowErrorModal(false)}
                                        aria-label="Close"
                                    ></button>
                                </div>
                                <div className="modal-body">
                                    <p className="text-danger mb-2">{message}</p>

                                    <div style={{ wordBreak: 'break-all', whiteSpace: 'pre-wrap', color: '#333' }}>
                                        {error}
                                    </div>
                                    <div className="row mt-3 mb-0">
                                        <div className="d-flex-center cus-dashborad-button">
                                            {/* <button className=""> */}
                                            <a href="/login" onClick={logout} className="btn btn-outline-custom mr-3">
                                                {/* <img className="cus-google-icon" src="assets/images/google-icon.svg" alt="Google" />  */}
                                                Connect Again
                                            </a>
                                            {/* </button> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
